// Keep the journal available by its URL while its homepage section is on hold.
export const SHOW_FIELD_NOTES = false;
